import TwoFactorPage from './TwoFactorPage';
export default TwoFactorPage;
